// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { useUnreadThreadCount } from '@polarissleep/messaging';
import { IconMessageCircle } from '@tabler/icons-react';
import type { JSX } from 'react';
import { SidebarCountIcon } from './SidebarNotificationIcon';

interface SidebarUnreadInboxIconProps {
  readonly recipientRef: string | undefined;
}

/**
 * Sidebar icon for the Inbox link. Counts distinct parent threads in the Unread
 * bucket (last child message is from someone else and lacks the
 * notification-readAt extension). Mirrors the same logic that drives the
 * Unread bucket in ThreadInbox so the badge always matches what the user sees.
 */
export function SidebarUnreadInboxIcon({ recipientRef }: SidebarUnreadInboxIconProps): JSX.Element {
  const count = useUnreadThreadCount({ recipientRef });
  return <SidebarCountIcon count={count} iconComponent={<IconMessageCircle />} />;
}
